import React, { useState, useEffect, Fragment } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

function LoadMoreSkeleton() {
  return (
    <>
      {Array(8).fill().map((_, index) => (
        <div className="col-md-3 cardItem" style={{ padding: '5px' }} key={index}>
          <div className="cardItem-item">
            <div className="img-card imgCard">
              <Skeleton className='skeleton img-item' variant="rect" style={{ width: '90%', height: '90%' }} />
            </div>
            <div className="card-content" style={{ width: '100%' }}>
              <div className='title-card'>
                <Skeleton className='skeleton' variant="rect" style={{ height: '12px', width: '100%' }} />
                <Skeleton className='skeleton' variant="rect" style={{ height: '12px', width: '90%', marginTop: '5px' }} />
              </div>
              <div className="content-item">
                <Skeleton className='skeleton' variant="rect" style={{ height: '12px', width: '50%' }} />
              </div>
              <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <Skeleton className='skeleton' variant="rect" style={{ height: '12px', width: '30%' }} />
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default LoadMoreSkeleton;